import { Injectable } from '@angular/core';
import { CreditHealthService } from '../services/credit-health.service';
import { Actions } from '@ngrx/effects';
import { ApiEffects } from '../../../utils/effects.util';
import { selectCreditHealth } from './credit-health.selector';
import { Store } from '@ngrx/store';
import { creditHealthActions } from './credit-health.action';

@Injectable()
export class CreditHealthEffect extends ApiEffects {
  constructor(
    readonly actions$: Actions,
    private readonly creditHealthService: CreditHealthService,
    private readonly store: Store
  ) {
    super(actions$);
  }

  getCreditHealth$ = this.createCachedApiEffect({
    actions: creditHealthActions,
    effectFn: () => this.creditHealthService.getCreditHealth(),
    cachedObservable: this.store.select(selectCreditHealth),
  });
}
